import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { GraphDotnetService, graphql, MediaclipMutationUpdateStoreConfigArgs, Store, UpdateStoreCleanupConfigInput, UpdateStoreConfigInput } from 'app/shared/graph';

@Injectable({ providedIn: 'root' })
export class CleanupConfigService {
    private readonly graphDotnetService = inject(GraphDotnetService);

    getStoreCleanupConfig(storeId: string): Observable<Store> {
        return this.graphDotnetService.query(graphql`
                query getStoreSettings($storeId: String!) {
                    store(id: $storeId) {
                        label
                        subscription {
                            id
                            cleanup {
                                projectExpirations {
                                    giftingNotificationDelayInDays
                                    photobookNotificationDelayInDays
                                    printNotificationDelayInDays
                                }
                                pendingProjectExpirations {
                                    giftingNotificationDelayInDays
                                    photobookNotificationDelayInDays
                                    printNotificationDelayInDays
                                }
                            }
                        }
                        cleanupConfig {
                            printNotificationDelayInDays
                            giftingNotificationDelayInDays
                            photobookNotificationDelayInDays
                        }
                    }
                }
            `,
            {
                storeId
            }
        ).pipe(map(q => q.store));
    }

    updateStoreCleanupConfig(input: UpdateStoreCleanupConfigInput): Observable<void> {
        return this.graphDotnetService.mutate<MediaclipMutationUpdateStoreConfigArgs>(
            graphql`
                mutation updateStoreCleanupConfig($input: UpdateStoreCleanupConfigInput!) {
                    updateStoreCleanupConfig(input: $input)
                }
            `,
            { input }
        ).pipe(map(x => x.updateStoreConfig));
    }
}
